import React from 'react';

export interface Props {
  text: string;
}

/**
 * 改行付きテキスト
 */
export const TextWithLF: React.FC<Props> = ({ text }) => {
  const separator = /\r\n|\n|<br>|<br\/>|<br \/>|<br><\/br>/;

  return (
    <>
      {text.split(separator).map((str, idx) => (
        <React.Fragment key={idx}>
          {str}
          <br />
        </React.Fragment>
      ))}
    </>
  );
};
